import './audit-campaign-search-menu.scss'

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { AddItemModal } from '@skinsoft/ui';
import Component from 'vue-class-component';
import { OPEN_ADD_ITEM_MODAL } from '../../../../busTopics';

@Component({
    components: {
        sAddItemModal: AddItemModal
    },
    props: [''],
    template: require('./audit-campaign-search-menu.html')
})
export class AuditCampaignSearchMenu extends ReactiveVue {

    public openModal() {
        this.emitOnBus(OPEN_ADD_ITEM_MODAL)
    }

}